// extracted by mini-css-extract-plugin
export default {"button":"ConfirmButton_button__HqZiv","mobile":"ConfirmButton_mobile__9tLRB","text":"ConfirmButton_text__jlrWu typography_button__GDId3 undefined"};